import questionImg from '../../../img/question_mark.svg';
import supportImg from '../../../img/support.svg';
import shareImg from '../../../img/share.png';
import videoImg from '../../../img/video.svg';
import imageImg from '../../../img/image.svg';
import musicImg from '../../../img/music.svg';
import speechImg from '../../../img/speech.svg';
import videoEditorImg from '../../../img/video-editor.svg';

export const getDrawerItems = t => {
  return {
    music: {
      title: [{ text: t('appBar.music'), icon: musicImg }],
      links: [
        { text: t('inferenceTab.title'), to: 'generate-music' },
        { text: t('trainingTab.title'), to: 'train-voice' },
        { text: t('ttmInference.title'), to: 'generate-ttm' },
        { text: t('vocalExtractorTab.title'), to: 'vocal-extract' },
      ],
    },
    speech: {
      title: [{ text: t('appBar.speech'), icon: speechImg }],
      links: [
        { text: t('ttsInferenceTab.title'), to: 'generate-tts' },
        { text: t('ttsTrainingTab.title'), to: 'tts-train-voice' },
      ],
    },
    image: {
      title: [{ text: t('appBar.image'), icon: imageImg }],
      links: [
        { text: t('ttiInferenceTab.title'), to: 'generate-tti' },
        { text: t('ttiTrainingTab.title'), to: 'tti-train-image' },
      ],
    },
    video: {
      title: [{ text: t('appBar.video'), icon: videoImg }],
      links: [
        { text: t('faceSwapTab.title'), to: 'faceswap' }
      ],
    },
    videoEditor: {
      links: [
        { text: t('videoEditorTab.title'), icon: videoEditorImg, to: 'video-editor' },
      ],
    },
    community: {
      links: [
        { text: t('communityTab.title'), icon: shareImg, to: 'community' },
      ],
    },
    history: {
      title: [{ text: t('appBar.history') }],
      links: [
        { text: t('historyTab.creations.title'), to: 'creations' },
        { text: t('historyTab.models.title'), to: 'models' },
      ],
    },
    account: {
      links: [
        { text: t('subscriptionTab.title'), to: 'subscription' },
      ],
    },
    help: {
      links: [
        { text: t('faqTab.title'), icon: questionImg, to: 'faq' },
        { text: t('contactTab.title'), icon: supportImg, to: 'contact' },
      ],
    },
  };
};
